import {
  getSdk,
  UapiAgronomicActivityType,
  UapiBackendMachineDataSource,
  UapiGetFieldLayersQuery,
} from '../../graphql/sdk';
import type { SeasonName } from '../../types/Season';
import { getGraphqlClient } from '../uapiConnection';
import { LegendItemType, MachineDataMap } from './types';

interface MachineDataMapsQueryVariables {
  fieldId: string;
  activityType: UapiAgronomicActivityType;
  seasonName: SeasonName;
  cropId: string;
  seasonYear: number;
  harvestArdEnabled: boolean;
}

const adaptLegend = (legend) => ({
  units: legend.units ?? null,
  items: legend.items.map((item) => {
    // eslint-disable-next-line no-underscore-dangle
    const itemType = item.__typename;
    const color = {
      alpha: item.color.alpha ?? null,
      blue: item.color.blue,
      green: item.color.green,
      red: item.color.red,
    };

    if (itemType === 'CategoricalGeospatialAssetLegendItem') {
      return {
        // eslint-disable-next-line no-underscore-dangle
        __typename: LegendItemType.Categorical,
        label: item.label,
        color,
      };
    }

    return {
      // eslint-disable-next-line no-underscore-dangle
      __typename: LegendItemType.Continuous,
      min: item.min ?? null,
      max: item.max ?? null,
      color,
    };
  }),
});

const adaptFieldLayersToMachineDataMaps = (response: UapiGetFieldLayersQuery): MachineDataMap[] =>
  (response.field?.machineDataMaps?.maps ?? []).map((map) => ({
    name: map.name,
    assets: (map.assets ?? []).map((asset) => ({
      thumbnailUrl: asset.thumbnailUrl ?? null,
      version: asset.version ?? null,
      tileUrlTemplate: asset.tileUrlTemplate,
      source: asset.source,
      legend: adaptLegend(asset.legend),
    })),
  }));

export async function requestAgVizMachineDataMaps({
    activityType,
    cropId,
    fieldId,
    seasonName,
    seasonYear,
    harvestArdEnabled
}: MachineDataMapsQueryVariables): Promise<MachineDataMap[]> {
  const notImplementedActivities = [
    UapiAgronomicActivityType.PROTECTING,
    UapiAgronomicActivityType.HARVESTING
  ];
  const sdk = getSdk(getGraphqlClient());
  let backendMachineDataSource = UapiBackendMachineDataSource.COMBINED;
  if(notImplementedActivities.includes(activityType) && !harvestArdEnabled) {
    backendMachineDataSource = UapiBackendMachineDataSource.LEGACY;
  }
  
  const response = await sdk.getFieldLayers({ 
    activityType,
    cropId,
    fieldId,
    seasonName,
    seasonYear,
    backendMachineDataSource
  });

  return adaptFieldLayersToMachineDataMaps(response.data);
}
